import { useMemo } from 'react';
import type { AppLocale } from './SeoLinks';

export interface SeoListItem {
  name: string
  url: string
}

interface StructuredDataProps {
  data?: object | object[] | null
}

export const getSeoHomeName = (locale: AppLocale) => {
  return locale === 'fr_CA' ? 'Accueil' : 'Home';
}

export const getSeoProductsName = (locale: AppLocale) => {
  return locale === 'fr_CA' ? 'Produits' : 'Products';
}

export const buildBreadcrumbListSchema = (items: SeoListItem[]) => ({
  '@context': 'https://schema.org/',
  '@type': 'BreadcrumbList',
  name: items.map(item => item.name).join(' > '),
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url,
  })),
});

export default function StructuredData(props: StructuredDataProps) {
  const schemaJson = useMemo(() => {
    return props.data !== undefined && props.data !== null ? JSON.stringify(props.data) : '';
  }, [props.data]);

  if (schemaJson === '') {
    return null;
  }

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: schemaJson }} />;
}
